<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        Surat Peringatan
        <div class="card-header-actions">
          <button class="btn btn-success mr-1" @click="save({ print: 1 })">
            <i class="fa fa-print"></i> {{ $t('printsave') }}
          </button>
          <button class="btn btn-primary mr-1" @click="save({ print: 0 })">
            <i class="fa fa-floppy-o"></i> {{ $t('save') }}
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t('cancel') }}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input readonly v-model="model.no_kontrak" @keyup.13.native="lkuPinjamanShow = true"
                  :state="!$v.model.pinjamankey.$error"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow = true" v-show="!this.$route.params.suratkey">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tgl. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tgl_kontrak" type="date" disabled style="float: right;"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Agreement</label>
                </b-input-group-prepend>
                <span class="pt-2">
                  <a :href="viewaggrementcard()" target="_blank"> {{ model.no_agreement }}</a>
                </span>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 79px">Model Pinjaman</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.model_pinjaman" disabled></b-form-input>
              </b-input-group>
              <!-- <a :href="viewaggrementcard()" target="_blank"><i class="fa fa-eye"></i> View Aggrement Card</a> -->
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.uraian" disabled></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman == 'PAB'">
                <label style="width:150px;">Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label style="width:150px;">Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number v-if="model.model_pinjaman == 'PAB'" class="form-control text-right" v-model="model.principal"
                :precision="2" disabled></my-number>
              <my-number v-else class="form-control text-right" v-model="model.principal" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{ model.matauang }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:150px;">Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.bunga_tarifthn" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman == 'PAB'">
              <b-input-group-prepend>
                <label style="width:150px;">Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.installment_amount" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{ model.matauang }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label style="width:150px;">Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.bungaod_tarifthn" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />


      <b-card no-body border-variant="info" header="History SP" align="center" v-show="!this.$route.params.pinjamankey">
        <b-table class="mb-0" ref="table" outlined responsive hover style="font-size: smaller" :items="dataSPHistory"
          :fields="tblFields" show-empty>

          <template v-slot:cell(tglsurat)="data">{{
            data.item.tglsurat | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(expiredate)="data">{{
            data.item.expiredate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(tglperhitungan)="data">{{
            data.item.tglperhitungan | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(tunggakanpokok)="data">{{
            data.item.tunggakanpokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(tunggakanbunga)="data">{{
            data.item.tunggakanbunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(tunggakandenda)="data">{{
            data.item.tunggakandenda | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(tunggakantotal)="data">{{
            data.item.tunggakantotal | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(delivery_status)="data">
            <div v-if="(data.item.delivery_status != null)">
              <span v-if="data.item.delivery_status == 'return'">
                Diretur pada {{ data.item.returndate | moment('YYYY-MM-DD') }}
              </span>
              <span v-else>
                Dikirim pada {{ data.item.deliverydate | moment('YYYY-MM-DD') }}
              </span>
            </div>
          </template>
          <template v-slot:cell(delivery_info)="data">
            <div v-if="(data.item.noresi || '') != ''">
              {{ (data.item.jasapengiriman).toUpperCase() }} | No. Resi : {{ data.item.noresi }}
            </div>
          </template>
        </b-table>
      </b-card>


      <hr v-show="!this.$route.params.suratkey" />
      <b-card border-variant="info" header="Detail Info" align="center">
        <b-card-text>
          <b-form @submit="event.preventDefault()">
            <b-row>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tanggal Surat</label>
                  </b-input-group-prepend>
                  <b-input type="date" v-model="model.tglsurat" :state="!$v.model.tglsurat.$error" />
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Nomor Surat</label>
                  </b-input-group-prepend>
                  <b-form-input v-if="this.$route.params.suratkey" v-model="model.nosurat"
                    :state="!$v.model.nosurat.$error" disabled></b-form-input>
                  <b-form-input v-else v-model="model.nosurat" :state="!$v.model.nosurat.$error"></b-form-input>
                </b-input-group>

                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width: 200px" class="text-right">Beda Alamat </label>
                  </b-input-group-prepend>
                  <b-form-radio-group v-model="model.isaddressdiff" :options="optionsisaddressdiff" class="mb-3 mt-1"
                    value-field="item" text-field="name"></b-form-radio-group>
                  <b-input-group-append>
                    <label class="p-1">(Dengan Sistem)</label>
                  </b-input-group-append>
                </b-input-group>
                <div v-if="model.isaddressdiff == 1">
                  <b-input-group>
                    <b-input-group-prepend>
                      <label style="width:200px;" class="text-right">Alamat Surat</label>
                    </b-input-group-prepend>
                    <b-form-textarea id="textareaalamat" v-model="model.alamat" placeholder="Alamat surat.." rows="3"
                      max-rows="6"></b-form-textarea>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <label style="width:200px;" class="text-right">RT</label>
                    </b-input-group-prepend>
                    <b-form-input v-model="model.rt" style="max-width:200px;"></b-form-input>
                    <b-input-group-append>
                      <label style="width:200px;" class="text-right pt-1 mr-1">RW</label>
                    </b-input-group-append>
                    <b-form-input v-model="model.rw" style="max-width:200px;"></b-form-input>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <label style="width:200px;" class="text-right">Kelurahan</label>
                    </b-input-group-prepend>
                    <b-form-input v-model="model.kelurahan" style="max-width:200px;"></b-form-input>
                    <b-input-group-append>
                      <label style="width:100px;" class="text-right pt-1 mr-1">Kecamatan</label>
                    </b-input-group-append>
                    <b-form-input v-model="model.kecamatan" style="max-width:200px;"></b-form-input>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <label style="width:200px;" class="text-right">Kota/Kabupaten</label>
                    </b-input-group-prepend>
                    <b-form-input v-model="model.kota" style="max-width:200px;"></b-form-input>
                    <b-input-group-append>
                      <label style="width:100px;" class="text-right pt-1 mr-1">Provinsi</label>
                    </b-input-group-append>
                    <b-form-input v-model="model.provinsi" style="max-width:200px;"></b-form-input>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <label style="width:200px;" class="text-right">Kode Pos</label>
                    </b-input-group-prepend>
                    <b-form-input v-model="model.kodepos" style="max-width:200px;"></b-form-input>
                  </b-input-group>
                </div>
                <div v-else>
                  <b-input-group>
                    <b-input-group-prepend>
                      <label style="width:200px;" class="text-right">Alamat Surat</label>
                    </b-input-group-prepend>
                    <b-form-textarea id="textareaalamat" v-model="model.alamatsurat"
                      :state="!$v.model.alamatsurat.$error" placeholder="Alamat surat.." rows="3" max-rows="6"
                      disabled></b-form-textarea>
                  </b-input-group>

                </div>

                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Jenis Surat</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="model.jenissuratkey" :state="!$v.model.jenissuratkey.$error"
                    :options="optJenisSurat"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Masa Berlaku</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="model.validPeriodVal" :options="optionsValidPeriodVal"
                    :state="!$v.model.validPeriodVal.$error"></b-form-select>
                  <b-form-select v-model="model.validPeriodUOM" :options="optionsValidPeriodUOM"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Berlaku sampai</label>
                  </b-input-group-prepend>
                  <b-form-input readonly class="form-control-plaintext"
                    :value="model.expiredate | moment('DD MMM YYYY')"></b-form-input>
                  <!-- <b-form-input
                    type="date"
                    v-model="model.expiredate"
                    :state="!$v.model.expiredate.$error"
                    :min="model.tglsurat | moment('YYYY-MM-DD')"
                    disabled
                  ></b-form-input> -->
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Status</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="model.statussp" :options="optionsStts"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right"><strong>Rekening Pembayaran</strong></label>
                  </b-input-group-prepend>
                  <div style="margin-left:100px;min-width: calc(100% - 100px)">
                    <b-input-group>
                      <b-input-group-prepend>
                        <label class="text-right">Nama Bank</label>
                      </b-input-group-prepend>
                      <b-form-input v-model="model.namabank" :disabled="(user.role_name=='user')"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <label class="text-right">Nomor Rekening</label>
                      </b-input-group-prepend>
                      <b-form-input v-model="model.vanumber" :disabled="(user.role_name=='user')"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <label class="text-right">Nama Akun Bank</label>
                      </b-input-group-prepend>
                      <b-form-input v-model="model.accowner" :disabled="(user.role_name=='user')"></b-form-input>
                    </b-input-group>
                  </div>
                </b-input-group>
                <!-- <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Keterangan</label>
                  </b-input-group-prepend>
                  <b-form-textarea id="textarea" v-model="model.note" placeholder="Tambahkan keterangan.." rows="3"
                    max-rows="6"></b-form-textarea>
                </b-input-group> -->
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Confirm Phone</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.confirmphone"></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tembusan</label>
                  </b-input-group-prepend>
                  <b-form-textarea id="textarea" v-model="model.tembusan" placeholder="Tambahkan tembusan.." rows="3"
                    max-rows="6"></b-form-textarea>
                </b-input-group>
              </b-col>
              <b-col lg="5">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tgl Perhitungan</label>
                  </b-input-group-prepend>
                  <b-input type="date" v-model="model.tglperhitungan" :state="!$v.model.tglperhitungan.$error"
                    class="ml-2 mr-2" :disabled="!this.model.pinjamankey"></b-input>
                  <b-button variant="danger" v-b-tooltip.hover title="Hitung biaya pelunasan"
                    :disabled="!this.model.pinjamankey" @click="calculate">
                    <i class="fa fa-calculator"></i> Calc.
                  </b-button>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tunggakan Pokok</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text ml-2" style="width:70px;">IDR</span>
                  </b-input-group-prepend>
                  <my-number disabled v-model="model.tunggakanpokok" :precision="2" class="text-right"></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tunggakan Bunga</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text ml-2" style="width:70px;">IDR</span>
                  </b-input-group-prepend>
                  <my-number disabled v-model="model.tunggakanbunga" :precision="2" class="text-right"></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Denda Keterlambatan</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text ml-2" style="width:70px;">IDR</span>
                  </b-input-group-prepend>
                  <my-number disabled v-model="model.tunggakandenda" :precision="2" class="text-right"></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Total Tunggakan</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text ml-2" style="width:70px;">IDR</span>
                  </b-input-group-prepend>
                  <my-number disabled v-model="model.tunggakantotal" :precision="2" class="text-right"></my-number>
                </b-input-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col lg="6">
                <h6 class="text-center">Penandatangan</h6>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:100px;">Nama</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.ttd1nama"></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:100px;">Jabatan</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.ttd1jabatan"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-text>
      </b-card>

      <b-card no-body border-variant="info" header="History Delivery" align="center"
        v-show="!this.$route.params.pinjamankey">

        <b-table class="mb-0" ref="tabledeliveryHistory" outlined responsive hover style="font-size: smaller"
          :items="deliveryHistory" :fields="tblFieldsHistoryDelivery" show-empty>
          <template #thead-top="data">
            <b-tr>
              <b-th colspan="3" variant="primary">Delivery</b-th>
              <b-th colspan="2" variant="warning">Retur</b-th>
            </b-tr>
          </template>

          <template v-slot:cell(status)="data">{{ (data.item.status).toUpperCase() }}</template>
          <template v-slot:cell(deliverydate)="data">{{
            data.item.deliverydate | moment("DD MMM YYYY")
          }}</template>
          <template v-slot:cell(returndate)="data">{{
            data.item.returndate | moment("DD MMM YYYY")
          }}</template>
          <template v-slot:cell(jasapengiriman)="data">{{ (data.item.jasapengiriman).toUpperCase() }}</template>
          <template v-slot:cell(pengirim2)="data">
            {{ data.item.noresi }}
            {{ data.item.dikirimoleh }}
          </template>
          <template v-slot:cell(createInfo)="data">
            <span v-if="(data.item.createby || '') !== ''">
              {{ data.item.createby }} @ {{
            data.item.created_date | moment("DD MMM YYYY")
          }}
            </span>
          </template>
          <template v-slot:cell(updateInfo)="data">
            <span v-if="(data.item.modified_by || '') !== ''">
              {{ data.item.modified_by }} @ {{
            data.item.modified | moment("DD MMM YYYY")
          }}
            </span>
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <!-- <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              | -->
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteHistoryConfirm(data.item.historykey)">
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>


        </b-table>

      </b-card>
    </b-card>
    <b-modal v-model="lkuPinjamanShow" size="lg" :hide-footer="true" title="Daftar Pinjaman" :centered="true">
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuPinjaman from "./lkuPinjaman";
import speringatan from "../../apis/suratperingatan";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman, Loading },
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
      nosurat: { required },
      jenissuratkey: { required },
      tglsurat: { required },
      expiredate: { required },
      //lamahari: { required },
      //ttd1nama: { required },
      //ttd2nama: { required },
      //ttd1jabatan: { required },
      //ttd2jabatan: { required },
      tglperhitungan: { required },
      //statussp: { required },
      alamatsurat: { required },
      validPeriodVal: { minValue: minValue(1) }
    },
  },
  data() {
    return {
      isLoading: false,
      showReport: false,
      reportUrl: "",
      model: {
        suratkey: false,
        no_kontrak: "",
        pinjamankey: "",
        model_pinjaman: "",
        principal: "",
        matauang: "",
        interest: "",
        installment_amount: "",
        interestod: "",
        tglsurat: moment().format('YYYY-MM-DD'),
        expiredate: "",
        lamahari: "",
        tembusan: `- Bagian Hukum/Legal\n- Bagian Penagihan dan Lelang\n- Koordinator Area dan Tim Penanganan`,
        statussp: null,
        nosurat: "",
        jenissuratkey: null,
        tunggakanpokok: 0,
        tunggakanbunga: 0,
        tunggakandenda: 0,
        tunggakantotal: 0,
        ttd1nama: "",
        ttd1jabatan: "",
        confirmphone: "",
        tglperhitungan: moment().format("YYYY-MM-DD"),
        validPeriodVal: 0,
        validPeriodUOM: 'weeks',
        isaddressdiff: 0, alamatsuratsistem: '', alamatsurat: '',
        alamat: '',
        rt: '',
        rw: '',
        kelurahan: '',
        kecamatan: '',
        kota: '',
        provinsi: '',
        kodepos: '',
        pjxcode:'',
        pjxname:''
      },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglsurat",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        jenissuratkey: null,
      },
      optionsStts: [
        { value: null, text: "Pilih status" },
        { value: "lancar", text: "Lancar" },
        { value: "gugur", text: "Gugur" },
      ],
      optJenisSurat: [
        {
          value: null,
          text: "-- Please select an option --",
          disabled: true,
        },
      ],
      optionsValidPeriodVal: [
        { value: 0, text: "-- Please select an option --" },
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
      ],
      optionsValidPeriodUOM: [
        { value: 'weeks', text: "MINGGU" },
        { value: 'months', text: "BULAN" }
      ],
      optionsisaddressdiff: [
        { item: 0, name: "Tidak" },
        { item: 1, name: "Ya" },
      ],
      lkuPinjamanShow: false,
      deliveryHistory: []
      //calcShow: true,
    };
  },
  created: async function () {
    if (this.$route.params.suratkey) {
      toastr.info("Loading Payment Detail, please wait");
      try {
        const [res, deliveryHistory] = await Promise.all([
          speringatan.detail(this.$route.params.suratkey),
          speringatan.deliveryHistoryBySP(this.$route.params.suratkey)
        ])


        for (const key in res) {
          if (res.hasOwnProperty(key)) {
            this.model[key] = res[key];
          }
        }
        this.model.tglsurat = moment(this.model.tglsurat).format("YYYY-MM-DD");
        this.model.expiredate = moment(this.model.expiredate).format(
          "YYYY-MM-DD"
        );
        this.model.alamatsurat = this.model.alamatsurat.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
        this.model.alamatsuratsistem = this.model.alamatsurat;

        this.model.validPeriodVal = moment(this.model.expiredate).diff(moment(this.model.tglsurat), 'weeks') > 4 ? moment(this.model.expiredate).diff(moment(this.model.tglsurat), 'weeks') / 4 : moment(this.model.expiredate).diff(moment(this.model.tglsurat), 'weeks');
        this.model.validPeriodUOM = moment(this.model.expiredate).diff(moment(this.model.tglsurat), 'weeks') > 4 ? 'months' : 'weeks';

        this.model.tgl_kontrak = moment(this.model.tgl_kontrak).format(
          "YYYY-MM-DD"
        );

        this.model.tglperhitungan = this.model.tglperhitungan
          ? moment(this.model.tglperhitungan).format("YYYY-MM-DD")
          : "";
        this.$refs.table.refresh();
        this.deliveryHistory = deliveryHistory;
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      let prefix = 'MF';
      if (this.user.compcode == '02') prefix = 'MAM';

      this.model.nosurat = `/${prefix}/DIR/${this.integer_to_roman(parseInt(moment().format('M')))}/${moment().format('YYYY')}`
      
    }
    let workflowSP = await speringatan.getworkflowSP();
    this.model.ttd1nama = this.model.ttd1nama ? this.model.ttd1nama : workflowSP[0].full_name;
    this.model.ttd1jabatan = this.model.ttd1jabatan ? this.model.ttd1jabatan : workflowSP[0].jabatan;
    this.model.tembusan = this.model.tembusan ? this.model.tembusan : `Bagian Hukum/Legal\nBagian Penagihan dan Lelang Kantor Pusat\nKoordinator Area dan Tim Penanganan`;
    // this.model.confirmphone = this.model.confirmphone ? this.model.confirmphone : `08111279218`;

    const spDtset = {
      tablename: "surat-peringatan",
      page: 1,
      limit: 100,
      total: 0,
      sortBy: "nourut",
      sortDesc: "false",
    };
    const srtperingatan = await crud.list(spDtset);
    srtperingatan.map((item) => {
      this.optJenisSurat.push({
        value: item.jenissuratkey,
        text: item.namasurat,
      });
    });
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields() {
      const fields = [
        {
          key: "tglsurat",
          label: "Tgl. Surat",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nosurat",
          label: "No. Surat",
          thStyle: "width:90px",
          thClass: "text-center",
          sortable: true,
        },

        {
          key: "namasurat",
          label: "Jenis Surat",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "expiredate",
          label: "Berlaku Sampai",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "statussp",
          label: "Status",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "delivery_status",
          label: "Delivery Status",
          thStyle: "min-width:180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "delivery_info",
          label: "Delivery Info",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "tglperhitungan",
          label: "Tgl. Perhitungan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "ttd1nama",
          label: "Nama Penandatangan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "ttd1jabatan",
          label: "Jabatan Penandatangan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "createby",
          label: "DIterbitkan Oleh",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    tblFieldsHistoryDelivery() {
      const fields = [

        {
          key: "deliverydate",
          label: "Delivery Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "jasapengiriman",
          label: "Jasa Pengiriman",
          thStyle: "min-width:180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "pengirim2",
          label: "No Resi/Nama Pengirim",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "returndate",
          label: "Retur Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "returnnote",
          label: "Retur Note",
          thStyle: "min-width:180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "status",
          label: "Last Status",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "createInfo",
          label: "Created",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "updateInfo",
          label: "Updated",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "updateInfo",
          label: "Updated",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
    ifDif() {
      return this.model.isaddressdiff == 0 ? true : false;
    },
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    // onLamaHari: function(tgl) {
    //   const tglsurat = moment(this.model.tglsurat).format("YYYY-MM-DD");
    //   const expiredate = moment(this.model.expiredate).format("YYYY-MM-DD");
    // },
    "model.isaddressdiff"(val) {
      // document.getElementById("textareaalamat").disabled = val == 0 ? true : false;
      if (val == 0) {
        this.model.alamatsurat = this.model.isaddressdiff == 0 ? this.model.alamatsuratsistem : this.model.alamatsurat;
      }
    },
    "model.tglsurat"(val) {
      const expiredate = moment(val).add(this.model.validPeriodVal, this.model.validPeriodUOM);
      this.model.expiredate = moment(expiredate).format("YYYY-MM-DD");
    },
    "model.validPeriodVal"(val) {
      const expiredate = moment(this.model.tglsurat).add(val, this.model.validPeriodUOM);
      this.model.expiredate = moment(expiredate).format("YYYY-MM-DD");
    },
    "model.validPeriodUOM"(val) {
      const expiredate = moment(this.model.tglsurat).add(this.model.validPeriodVal, val);
      this.model.expiredate = moment(expiredate).format("YYYY-MM-DD");
    },
  },
  methods: {
    integer_to_roman(num) {
      if (typeof num !== 'number')
        return false;

      var digits = String(+num).split(""),
        key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
          "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
          "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
        roman_num = "",
        i = 3;
      while (i--)
        roman_num = (key[+digits.pop() + (i * 10)] || "") + roman_num;
      return Array(+digits.join("") + 1).join("M") + roman_num;
    },

    async onSelectLkuPinjaman(_selected) {
      try {
        this.model.pinjamankey = _selected.pinjamankey;
        this.model.nasabahkey = _selected.nasabahkey;
        this.model.no_kontrak = _selected.no_kontrak;
        this.model.tgl_kontrak = _selected.tgl_kontrak;
        this.model.CustName = _selected.CustName;
        this.model.uraian = _selected.uraian;
        this.model.model_pinjaman = _selected.model_pinjaman;
        this.model.principal = _selected.principal;
        this.model.plafon = _selected.plafon;
        this.model.bunga_tarifthn = _selected.bunga_tarifthn;
        this.model.installment_amount = _selected.installment_amount;
        this.model.bungaod_tarifthn = _selected.bungaod_tarifthn;
        this.model.alamat = _selected.alamat;
        this.model.rt = _selected.rt;
        this.model.rw = _selected.rw;
        this.model.kelurahan = _selected.kelurahan;
        this.model.kecamatan = _selected.kecamatan;
        this.model.kota = _selected.kota;
        this.model.provinsi = _selected.provinsi;
        this.model.kodepos = _selected.kodepos;
        this.model.namabank = _selected.namabank2;
        //this.model.cabang = _selected.cabang;
        this.model.bankcode = _selected.bankcode;
        this.model.vanumber = _selected.vanumber;
        this.model.accowner = _selected.accowner;
        this.model.no_agreement = _selected.no_agreement;
        this.model.note = `${_selected.namabank} \n No Rekening Virtual Account: ${_selected.vanumber} \n Atas Nama: ${_selected.accowner}`;
        this.model.alamatsurat = `${_selected.alamat ? _selected.alamat.trim() : ""} RT.${_selected.rt ? _selected.rt.trim() : ""} RW.${_selected.rw ? _selected.rw.trim() : ""} \nKel. ${_selected.kelurahan ? _selected.kelurahan.trim() : ""} Kec. ${_selected.kecamatan ? _selected.kecamatan.trim() : ""} \nKota. ${_selected.kota ? _selected.kota.trim() : ""} ${_selected.kodepos ? _selected.kodepos.trim() : ""}`;
        this.model.alamatsurat = this.model.alamatsurat.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
        this.model.alamatsuratsistem = this.model.alamatsurat;
        this.model.pjxcode =_selected.pjxcode
        this.model.pjxname =_selected.pjxname
        this.model.tgl_kontrak = _selected.tgl_kontrak
          ? moment(_selected.tgl_kontrak).format("YYYY-MM-DD")
          : "";
        
        this.model.ttd1nama = _selected.signed_SP_by;
        this.model.ttd1jabatan = _selected.signed_SP_job_title;
        this.model.confirmphone = _selected.signed_SP_confirm_phone;
        this.lkuPinjamanShow = false;
        this.$refs.table.refresh();
      } catch (error) {
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async calculate() {
      try {
        this.isLoading = true;
        const res = await speringatan.calcPelunasan(this.model);
        const data = res[0]
        if (data[0]) {
          this.model.tunggakanpokok = data[0].sum_angsrn_principal;
          this.model.tunggakanbunga = data[0].sum_angsrn_interest;
          this.model.tunggakandenda = data[0].os_denda;
          this.model.count_angsuran = data[0].count_angsuran;
          this.model.angsuran_dari = data[0].angsuran_dari;
          this.model.angsuran_ke = data[0].angsuran_ke;
          this.model.tunggakantotal =
            this.model.tunggakanpokok +
            this.model.tunggakanbunga +
            this.model.tunggakandenda;

          if (this.model.model_pinjaman == "PAB") {
            this.model.tunggakanpokok = data[0].sum_angsrn_principal;
            this.model.tunggakanbunga = data[0].sum_angsrn_interest;
            this.model.tunggakandenda = data[0].os_denda;
            this.model.count_angsuran = data[0].count_angsuran;
            this.model.angsuran_dari = data[0].angsuran_dari;
            this.model.angsuran_ke = data[0].angsuran_ke;
            this.model.tunggakantotal =
              this.model.tunggakanpokok +
              this.model.tunggakanbunga +
              this.model.tunggakandenda;
          }

        }

        // if (this.model.pjxcode == "BTPN2023") {
        //   if (this.model.sisapembayaran < 100000000) {
        //     this.label.vanumber = 'Nomor Virtual Account';
        //   } else {
        //     this.label.vanumber = 'Nomor Account';
        //     this.model.vanumber = '526-0905637'
        //     this.model.namabank = 'BCA - PT MURNI ALDANA MANAJEMEN'

        //   }
        // }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    dataSPHistory: async function (ctx) {
      if (this.model.pinjamankey) {
        try {
          const list = await speringatan.listSPHistory(this.model);
          let suratkeyArr = [];
          if (list) {
            list.map((item, idx) => {
              suratkeyArr.push(item.suratkey);
            });
          }
          this.model.spreference = suratkeyArr.toString() || "";
          return list;
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        return [];
      }
    },
    async save({ print }) {
      try {
        if (this.invalidModel) {
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          //disini cek api dulu, apakah nomor surat sudah pernah ada sebelumnya!
          const dataNomorSP = await speringatan.ceknomorSP(this.model);
          if (!this.$route.params.suratkey && dataNomorSP) {
            toastr.warn(`SP dengan nomor surat: ${dataNomorSP.nosurat} sudah pernah dibuat sebelumnya. Silahkan cek kembali nomor surat!`, "INFO", "8000");
          } else {
            this.isLoading = true;
            let alamatsuratChanged = `${this.model.alamat ? this.model.alamat.trim() : ""} RT.${this.model.rt ? this.model.rt.trim() : ""} RW.${this.model.rw ? this.model.rw.trim() : ""} \nKel. ${this.model.kelurahan ? this.model.kelurahan.trim() : ""} Kec. ${this.model.kecamatan ? this.model.kecamatan.trim() : ""} \nKota. ${this.model.kota ? this.model.kota.trim() : ""} ${this.model.kodepos ? this.model.kodepos.trim() : ""}`;

            this.model.alamatsurat = this.model.isaddressdiff == 0 ? this.model.alamatsuratsistem : alamatsuratChanged;
            const res = await speringatan.save(this.model);
            if (res) {
              if (print) {
                this.model.suratkey = res.suratkey;
                this.reportUrl = await speringatan.printPDF(res);
                this.showReport = true;
                this.isLoading = false;
              } else {
                this.isLoading = false;
                toastr.success("Data berhasil disimpan");
                router.push({ name: "loan.history-sp" });
              }
            }
          }
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async deleteHistoryConfirm(historykey) {
      this.$bvModal.msgBoxConfirm('Anda yakin ingin menghapus data ini ?', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            try {
              this.isLoading = true;
              speringatan.deletedeliveryHistoryBySP(historykey);
              toastr.success("Data berhasil dihapus");
              let getIndex = this.deliveryHistory.findIndex(x => x.historykey == historykey);
              this.deliveryHistory.splice(getIndex, 1);
              this.$refs.tabledeliveryHistory.refresh();
              this.isLoading = false;
            } catch (error) {
              this.isLoading = false;
              if (error.message) {
                toastr.error(error.message, "ERROR MESSAGE", 10000);
              } else {
                toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
              }
            }
          }
        })
        .catch(err => {
          if (err.message) {
            toastr.error(err.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(err), "ERROR MESSAGE", 10000);
          }
        })



    },
    close() {
      router.push({ name: "loan.history-sp" });
    },
    viewaggrementcard() {
      const url = router.resolve({ name: 'loan.agreementcardparams', params: { pinjamankey: this.model.pinjamankey } }).route.path;
      return `#` + url;
    },
  },
};
</script>
